// src/components/Services.jsx
import { SERVICES } from '../data/content';
import './Services.css';

export default function Services() {
  return (
    <section id="services" className="services-section">
      <div className="container">
        <div className="section-head">
          <div className="section-head-text">
            <p className="section-label">What We Build</p>
            <h2>Services that move the needle.</h2>
            <p>From data ingestion to AI inference — we cover the full industrial intelligence stack.</p>
          </div>
          <a href="#contact" className="btn btn-outline">Work With Us →</a>
        </div>

        <div className="services-grid">
          {SERVICES.map((svc, i) => (
            <div
              key={svc.title}
              className={`service-card fade-in${i % 3 === 1 ? ' fade-in-delay-1' : i % 3 === 2 ? ' fade-in-delay-2' : ''}`}
            >
              <div className="service-icon" style={{ background: svc.color }}>
                {svc.icon}
              </div>
              <h3>{svc.title}</h3>
              <p>{svc.desc}</p>
              <span className="tag">{svc.tag}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
